export enum NextPaymentDetailsType {
  Active,
  Downgrade,
  Free,
  GracePeriod,
  PaymentDue
}
